import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigator" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "center fw-bold" }
const _hoisted_4 = { class: "text-magenta" }
const _hoisted_5 = { class: "ms-1 text-blue" }
const _hoisted_6 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevron_left = _resolveComponent("icon-chevron-left")!
  const _component_icon_chevron_right = _resolveComponent("icon-chevron-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, [
        _createVNode(_component_icon_chevron_left)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.date(_ctx.localValue, 'dddd')), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$filters.date(_ctx.localValue, 'DD MMM YYYY')), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, [
        _createVNode(_component_icon_chevron_right)
      ])
    ])
  ]))
}